/**
 * SocialSharing.js
 */

import $ from 'jquery';

class SocialSharing {

    constructor() {

        this.$body = $('body');
        this.$sharingButtons = $('[data-share]');

        this.bindClickEvents();

        $('.social-share').on('mouseenter mouseleave click', function () {

            $(this).hasClass('active') ? $(this).removeClass('active') : $(this).addClass('active');

        });

    }

    bindClickEvents() {

        this.$sharingButtons.on('click', (event) => {

            if ($.inArray(this.$body.attr('data-display-size'), ['tablet', 'phone']) !== -1) {
                return;
            }

            const $element = $(event.delegateTarget);
            const uri = $element.attr('href');
            let dimensions;

            event.preventDefault();

            if ($element.data('share') === 'facebook') {
                dimensions = [626, 436];
            } else {
                dimensions = [550, 390];
            }

            this.openWindow(uri, dimensions);

        });

    }

    openWindow(uri, size) {

        const width = size[0];
        const height = size[1];
        const left = (screen.width / 2) - (width / 2);
        const top = (screen.height / 2) - (height / 2);
        const options = [
            'toolbar=no',
            'location=no',
            'directories=no',
            'status=no',
            'menubar=no',
            'scrollbars=no',
            'resizable=no',
            'copyhistory=no',
            'width=' + width,
            'height=' + height,
            'top=' + top,
            'left=' + left,
        ];

        return window.open(uri, 'Share', options.join(','));

    }

}
new SocialSharing();